module.exports = __webpack_public_path__ + "media/3x/7-6ac9d335.png";